/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reseller_Pricing_Status_FilterInputs */

const id_reseller_pricing_status_filter = /** @type {(inputs: Reseller_Pricing_Status_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saring status`)
};

const en_reseller_pricing_status_filter = /** @type {(inputs: Reseller_Pricing_Status_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter by status`)
};

/**
* | output |
* | --- |
* | "Filter by status" |
*
* @param {Reseller_Pricing_Status_FilterInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const reseller_pricing_status_filter = /** @type {((inputs?: Reseller_Pricing_Status_FilterInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reseller_Pricing_Status_FilterInputs, { locale?: "id" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reseller_pricing_status_filter(inputs)
	return id_reseller_pricing_status_filter(inputs)
});